import React from 'react';
import { Icon } from '@iconify/react';

function Footer() {
	return (
		<footer className="border-t border-slate-800 mt-24">
			<div className="max-w-6xl mx-auto px-6 py-10 flex flex-col sm:flex-row items-center justify-between gap-4">
				<div>
					<span className="font-display font-bold text-white text-lg">KL<span className="text-accent">.</span></span>
					<p className="text-slate-600 text-xs mt-1">© {new Date().getFullYear()} Kimboh Lovette. All rights reserved.</p>
				</div>
				<div className="flex items-center gap-5">
					{[
						{ label: 'GitHub', href: 'https://www.github.com/kimbohlovette', icon: 'mdi:github' },
						{ label: 'LinkedIn', href: 'https://www.linkedin.com/in/kimbohlovette/', icon: 'ps:linkedin' },
						{ label: 'Twitter', href: 'https://www.twitter.com/kimbohlovette', icon: 'mdi:twitter' },
					].map(s => (
						<a key={s.label} href={s.href} target="_blank" rel="noreferrer" aria-label={s.label}
							className="text-slate-600 hover:text-white transition-colors duration-200 text-lg">
							<Icon icon={s.icon} />
						</a>
					))}
				</div>
			</div>
		</footer>
	);
}

export default Footer;
